function readEnv(name: string, fallback = '') {
  return (import.meta.env[name] as string | undefined) ?? fallback
}

export const env = {
  appName: readEnv('VITE_APP_NAME', 'HD Parrainage'),
  appVersion: readEnv('VITE_APP_VERSION', '1.0.0'),
  appEnv: readEnv('VITE_APP_ENV', 'local'),
  appUrl: readEnv('VITE_APP_URL', 'http://localhost:5175'),
  apiBaseUrl: readEnv('VITE_API_BASE_URL', 'http://localhost:8081/api'),
  realtimeEventsEnabled: readEnv('VITE_REALTIME_EVENTS_ENABLED', 'true') === 'true',
  realtimeEventsPath: readEnv('VITE_REALTIME_EVENTS_PATH', '/v1/events'),
  sentryDsn: readEnv('VITE_SENTRY_DSN'),
  gaMeasurementId: readEnv('VITE_GA_MEASUREMENT_ID'),
  analyticsEnabled: readEnv('VITE_ENABLE_ANALYTICS', 'false') === 'true',
}
